import cx from 'classnames'
import styles from './SingleLineText.css'
import _ from 'lodash'
import PropTypes from 'prop-types'

/**
 * content 為 props.content 或 props.input.value
 * 都沒有的就取 customDefaultValue 或 '--'
 */
const getContent = props => {
  const { content = '', customDefaultValue = '', defaultEmptyString } = props
  const contentFromProps = content || _.get(props, 'input.value', '')
  const defaultValue = (customDefaultValue === '' && !defaultEmptyString)
    ? '--'
    : customDefaultValue

  const isValidContent = !!contentFromProps
  return isValidContent
    ? contentFromProps
    : defaultValue
}

const SingleLineText = (props) => {
  const content = getContent(props)
  const { className, addonAfter = '', addonBefore = '' } = props
  return (
    <div
      data-role='single-line-text'
      className={cx(styles.SingleLineText, className)}
    >
      {`${addonBefore}${content}${addonAfter}`}
    </div>
  )
}

SingleLineText.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string,
  customDefaultValue: PropTypes.string,
  input: PropTypes.object
}

export default SingleLineText
